<div class="detail-container">
  <nb-card [nbSpinner]="!!(saving$|async)">
    <nb-card-header>
      <h5>Standardwerte</h5>
      <wr-edit-delete-button-group *ngIf="canEdit()" (edit)="onEdit()"></wr-edit-delete-button-group>
    </nb-card-header>
    <nb-card-body>
      <form *ngIf="form" [formGroup]="form">
        <div class="sub-card-body">
          <label class="section-title" for="conditionThresholds">Zustand Grenzwerte</label>
          <wr-threshold-slider id="conditionThresholds" formControlName="conditionThresholds"></wr-threshold-slider>
        </div>
        <div class="sub-card-body" formGroupName="inspectionIntervals">
          <span class="section-title">Begehungsintervalle</span>
          <div class="grid">
            <div class="col-12 md:col-6">
              <hau-form-field label="B1300 – Wohngebäude (Monate)">
                <input nbInput type="number" fullWidth formControlName="norm1300IntervalMonths" min="1">
              </hau-form-field>
            </div>
            <div class="col-12 md:col-6">
              <hau-form-field label="B1301 – Nicht-Wohngebäude (Monate)">
                <input nbInput type="number" fullWidth formControlName="norm1301IntervalMonths" min="1">
              </hau-form-field>
            </div>
          </div>
        </div>
      </form>
    </nb-card-body>
    <nb-card-footer *ngIf="canEdit()">
      <button [disabled]="!isEditing || form?.invalid" nbButton status="primary" (click)="submit()">Speichern</button>
    </nb-card-footer>
  </nb-card>
</div>
